export const REPAYMENTS_TABLE = 'repaymentsTable';
export const PAGE_NO = 'page';
export const PAGE_SIZE = 'size';
export const PLACEHOLDER_DASH = '---';
export const ACTIVE_ROW_INDEX = -1;
export const PAYMENT_GATEWAY = 'PAYMENT_GATEWAY';
export const BANK_LENGTH_WORD_LIMIT = 35;
export const MANDATE = 'MANDATE';
export const defaultRepaymentsTabPageRequest = {
  page: 0,
  size: 50
};
